<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
      :class="{ 'is-loaded': isLoaded }"
    >
      <div class="overlay">
        <!-- MIS ESQUINA / CjhgjABECERjhgjhA -->
        <div class="mis-xv-wrapper-fixed"></div>

        <!-- Nombres y Fecha -->
        <div
          ref="nombreRef"
          class="centered-text"
        >
          <br><br>
          Heidi<br> Singh<br> 
          <br><br>
      
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import imagenPortada from '@/assets/foto de portada_11zon_11zon (1).webp'

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null)
    const nombreRef = ref(null)
    const fechaRef = ref(null)
    const isLoaded = ref(false)

    onMounted(() => {
      // 1. Precargar la imagen en memoria antes de animar
      const img = new Image()
      img.src = imagenPortada

      const iniciarAnimacion = () => {
        isLoaded.value = true
        
        const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

        // Animación suave de entrada para el contenedor del fondo (Fade in + Zoom out sutil)
        if (fotoPortadaRef.value) {
          tl.fromTo(
            fotoPortadaRef.value,
            { opacity: 0, scale: 1.05 },
            { opacity: 1, scale: 1, duration: 1.2, ease: 'power2.out' }
          )
        }

        // Animación de los nombres
        if (nombreRef.value) {
          tl.from(nombreRef.value, {
            opacity: 0,
            y: 30,
            duration: 0.9,
            ease: 'back.out(1.2)'
          }, "-=0.6") // Comienza mientras el fondo se está revelando
        }

        // Animación de la fecha
        if (fechaRef.value && fechaRef.value.children.length > 0) {
          tl.from(fechaRef.value.children, {
            opacity: 0,
            y: 15,
            duration: 0.5,
            stagger: 0.08
          }, "-=0.4")
        }
      }

      // Si la imagen se descarga o ya estaba guardada en caché
      if (img.complete) {
        iniciarAnimacion()
      } else {
        img.onload = iniciarAnimacion
        // Fallback por si la red falla o tarda demasiado
        img.onerror = iniciarAnimacion
      }
    })

    return {
      fotoPortadaRef,
      nombreRef,
      fechaRef,
      isLoaded
    }
  }
}
</script>

<style scoped>
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  margin-top: 0px;
  background-image: 
    linear-gradient(to bottom, rgba(255,255,255,0), rgba(0, 0, 0, 0.119)), 
    url('@/assets/foto de portada_11zon_11zon (1).webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;
  /* Oculto inicialmente para prevenir el renderizado progresivo brusco */
  opacity: 0;
  will-change: opacity, transform;
}

.overlay {
  position: absolute;
  top: -10px;
  left: 0;
  width: 100%;
  height: 105%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 2;

  background: linear-gradient(
    to bottom,
    rgba(0,0,0,0.05),
    rgba(0,0,0,0.35)
  );
}

.mis-xv-wrapper-fixed {
  position: absolute;
  top: -25px;
  left: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.ornamento-img {
  width: 40px;
  opacity: 0;
  margin-top: 50px;
  filter: brightness(0) invert(1);
  margin-bottom: 4px;
}

.mis-xv-top {
  font-family: 'file';
  font-size: 20px;
  letter-spacing: 1px;
  color: white;
}

.centered-text {
  text-align: center;
  padding-top: 240px;
  font-family: 'CynthiaJuneJF', serif;
  font-size: 69px;
  margin-top: -55px;
  font-weight: 500;
  line-height: 1;
  color: #ffffff;
}

.fecha-evento {
  color: white;
  font-size: 18px;
  display: flex;
  gap: 10px;
  justify-content: center;
}
</style>